<template>  
  <component v-if="taskToPass" :is="getTaskDetailComponent()" :passedTask="taskToPass"></component>   
</template>

<script>

/* eslint-disable */

import YourTask from './YourTask';
//import OverdueRecallTask from '../../../OverdueRecall/components/OverdueRecallTask/OverdueRecallTask';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Task',
  props: ['task'],
  components: {
    YourTask
  },

  async created() {
    await this.init();
  },

  methods: {
    ...mapActions('tasks', ['getTask', 'setTask']),

    async init() {
      if(!this.task)
        await this.getTask({ taskID: this.$attrs.taskID});
    },
    getTaskDetailComponent() {
      let task = this.task ? this.task : this._task;
      //console.log(task);
      let taskType = task.TaskType;
      console.log('Task Type:' + taskType)
      let componentName;
      switch(taskType) {
        case 'YOUR_TASKS'     : componentName = 'YourTask'; break;
        //case 'OVERDUE_RECALL' : componentName = 'OverdueRecallTask'; break;
        default               : componentName = 'YourTask'; break;
      }
      console.log('ComponentName:' + componentName);
      return componentName;
    }
  },

  computed: {
    ...mapState({
        _task : state => state.tasks.task,
    }),

    taskToPass() {
      return this.task? this.task : this._task;
    }
  }
};
</script>

<style src="./Task.scss" lang="scss" scoped />
